module.exports = __webpack_public_path__ + "img/trading-small.a387fa89.jpg";